import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check } from 'lucide-react';
import { cn } from '../lib/utils';
/**
 * What a node reads, as one list. Every knowledge base appears once, and the
 * checkbox is its effective state rather than its source: the graph's are on
 * because the graph offers them, and turning one off here records that this
 * node refuses it rather than copying the rest.
 *
 * The two lists can never hold the same id, because a toggle always clears the
 * other one. The contract refuses a node that holds both, and the row that
 * would store it cannot exist.
 */
export function NodeKnowledgePicker({ available, fromGraph, added, excluded, onChange, }) {
    const graphIds = new Set(fromGraph);
    const excludedIds = new Set(excluded);
    const addedIds = new Set(added);
    const isOn = (id) => graphIds.has(id) ? !excludedIds.has(id) : addedIds.has(id);
    const toggle = (id) => {
        const withoutId = added.filter(x => x !== id);
        const unexcluded = excluded.filter(x => x !== id);
        if (isOn(id)) {
            onChange({
                knowledgeBaseIds: withoutId,
                excludedKnowledgeBaseIds: graphIds.has(id)
                    ? [...unexcluded, id]
                    : unexcluded,
            });
            return;
        }
        onChange({
            knowledgeBaseIds: graphIds.has(id) ? withoutId : [...withoutId, id],
            excludedKnowledgeBaseIds: unexcluded,
        });
    };
    // The graph's first, so its set reads as the baseline this node adjusts.
    const rows = [...available].sort((a, b) => {
        const bySource = Number(graphIds.has(b.id)) - Number(graphIds.has(a.id));
        return bySource !== 0 ? bySource : a.name.localeCompare(b.name);
    });
    return (_jsx("div", { className: "border rounded-md max-h-56 overflow-y-auto", children: rows.map(base => {
            const on = isOn(base.id);
            return (_jsxs("div", { className: cn('flex items-center gap-3 px-3 py-2 cursor-pointer transition-colors border-b last:border-b-0', on ? 'bg-primary/5' : 'hover:bg-muted/50'), onClick: () => toggle(base.id), children: [_jsx("div", { className: cn('flex h-4 w-4 items-center justify-center rounded border-2 transition-colors flex-shrink-0', on
                            ? 'border-primary bg-primary text-primary-foreground'
                            : 'border-muted-foreground/30'), children: on && _jsx(Check, { className: "h-2.5 w-2.5" }) }), _jsx("div", { className: "min-w-0 flex-1 truncate text-sm", children: base.name }), graphIds.has(base.id) && (_jsx("span", { className: cn('flex-shrink-0 rounded-full px-1.5 py-0.5 text-[10px] font-medium', on
                            ? 'bg-primary/10 text-primary'
                            : 'bg-muted text-muted-foreground'), children: on ? 'from graph' : 'off here' }))] }, base.id));
        }) }));
}
//# sourceMappingURL=NodeKnowledgePicker.js.map